import { object, string } from "yup"
import {
  INVESTMENT_OBJECTIVE_VALUES,
  RiskToleranceValues,
  TimeHorizonValues,
} from "../../account"
import { buildSchema } from "./util/build-schema"

export const MAX_NICKNAME_LENGTH = 20

const schema = object({
  investmentObjective: string().required().oneOf(INVESTMENT_OBJECTIVE_VALUES),
  nickname: string().max(MAX_NICKNAME_LENGTH).required(),
  riskTolerance: string().required().oneOf(RiskToleranceValues),
  timeHorizon: string().required().oneOf(TimeHorizonValues),
})

export const accountSchema = buildSchema("Account", schema)
